import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

import VeeValidate from "./plugins/VeeValidate"
import Convert from "./plugins/Convert"
import VueQuillEditor from "./plugins/VueQuillEditor"
import VueGoogleMaps from "./plugins/VueGoogleMaps"
import VueApexCharts from "./plugins/VueApexCharts"

import '@/assets/css/main.css'

import { TokenService } from "@/service/Storage.Service.js"

if (TokenService.getToken()) {
  store.commit("setToken", TokenService.getToken())
  store.commit("setUser", JSON.parse(TokenService.getUser()))
  store.commit("setMenu", JSON.parse(TokenService.getMenu()))
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  Convert,
  VeeValidate,
  VueQuillEditor,
  VueGoogleMaps,
  VueApexCharts,
  render: h => h(App)
}).$mount('#app')
